import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthorizationService } from '../services/authorization.service';
import { Observable } from 'rxjs';
import { AuthorizationResponse } from '../model/authorization-response.model';
import { User } from '../model/user.model';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authorizationService: AuthorizationService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const isApiUrl = request.url.includes('/api/');
    const credentials: AuthorizationResponse = this.authorizationService.getAuthorizationCredentials();
    const user: User = this.authorizationService.getUser();
    if (isApiUrl) {
      if (credentials) {
        request = request.clone({
          setHeaders: { Authorization: `Bearer ${credentials.access_token}` }
        });
      }
      if (user) {
        request = request.clone({
          params: request.params.set('UserID', user.Id)
        });
      }
    }

    return next.handle(request);
  }
}
